import { SearchConsoleAccountsFormFirstStepValidationSchema } from '@/modules/DomainsApi';

export const searchConsoleAccountsFormFirstStepValidationSchema: SearchConsoleAccountsFormFirstStepValidationSchema = {
  email: [
    { required: true, message: 'Введіть назву e-mail' },
    { type: 'email', message: 'E-mail має бути валідним' }
  ],
  backupEmailAddress: [
    { required: true, message: 'Введіть назву e-mail' },
    { type: 'email', message: 'E-mail має бути валідним' }
  ],
  password: [
    { required: true, message: 'Введіть пароль від акаунту' },
    { type: 'string', message: 'Пароль від акаунту має бути строкою' },
    { min: 1, max: 255, message: 'Пароль від акаунту має бути довжиною не менше 1 символа та не більше 255' }
  ],
  provider: []
};
